/*
Copyright 2023 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

export class Deferred<T> {
    public readonly promise: Promise<T>;
    public readonly resolve: (value: T) => void;
    public readonly reject: (err: Error) => void;
    private _value?: T;

    constructor() {
        let resolve;
        let reject;
        this.promise = new Promise<T>((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        })
        this.resolve = (value: T) => {
            this._value = value;
            resolve(value);
        };
        this.reject = reject;
    }

    get value(): T | undefined {
        return this._value;
    }
}
